"use client";

import { Box } from "@mui/material";
import AdPriceRibbon from "@/app/shared/ad/AdPriceRibbon";
import AdLabelRibbon from "@/app/shared/ad/AdLabelRibbon";
import AdListingModel from "@/models/AdListingModel";

export default function ListingCardRibbons({ ad }: { ad: AdListingModel }) {
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        marginTop: -2,
        justifyContent: "space-between",
      }}
    >
      <AdLabelRibbon ad={ad} alwaysSmall />
      <AdPriceRibbon ad={ad} alwaysSmall />
    </Box>
  );
}
